import React from 'react'

const DocumentManagementHero = () => {
    return (
        <section className="lg:py-28 lg:px-12 px-5 sm:px-6 py-28 bg-bgDefault text-white overflow-x-hidden">
            <div className='container w-full max-w-full xl:mx-auto xl:max-w-screen-xl'>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-8 w-full min-w-0'>
                    <div className='min-w-0 max-w-full'>
                        <h2 className="text-[26px] leading-[34px] sm:text-heading-4 lg:text-heading-1 font-dmsans font-bold tracking-[-0.06em] mb-8 break-words max-w-full ">
                            Document Management System with Advanced Capabilities
                        </h2>
                         <div className="flex flex-wrap gap-2 mt-2 mb-6">
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Java
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Spring Boot
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                ElasticSearch
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                OCR
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Jenkins
                            </span>
                        </div>
                         <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto break-words max-w-full lg:px-0">
                              We partnered with a leading Australian Document Management Solution provider, trusted by over 2,500
                              customers across the Asia-Pacific region and Europe, to architect and deliver an enterprise-grade document
                              management system. The solution successfully manages 10+ million documents with sub-0.5 second search performance,
                              reduces document processing time by 40%, and seamlessly integrates with SAP, ADP, and OpenText. Our advanced
                              OCR and ElasticSearch implementation achieved a 30% reduction in unauthorized access incidents while improving
                              customer satisfaction scores by 25%, establishing new industry benchmarks for document workflow automation.
                            </p>

                    </div>
                    <div className='min-w-0 max-w-full'>
                      <img src='/case_studies/title-banner/document-app-title-banner.png' alt='Document Management System' className='w-full h-auto max-w-full'></img>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default DocumentManagementHero
